var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-multiselect',{attrs:{"label":"Relation","placeholder":"Owner, Rider or Family","value":_vm.value,"options":_vm.options},on:{"input":function (ids) { return _vm.$emit('input', ids); },"clear":function($event){return _vm.$emit('clear')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-625ac13c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/HorseMemberRelationFilter.vue
// module id = 779
// module chunks = 30